<template>
  <div class="country">
    <!-- <h1>acquirer</h1> -->

    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters class="mt-2">
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs
            :items="[{ text: $t('countries'), disabled: true, href: '/' }]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <v-btn
            class="button_size"
            prepend-icon="mdi-plus"
            color="blue"
            @click="compose"
            v-if="
              this.global_permissions.includes(
                'ROLE_STAFF_ADMIN',
                'ROLE_STAFF_USER'
              )
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_country") }}
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="3">
        <v-text-field
          :loading="loading"
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchData"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="countries"
        class="elevation-1 custom-table-style"
        :search="search"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="green"
                @click="compose_update(item.raw.countryCode)"
                v-if="
                  this.global_permissions.includes(
                    'ROLE_STAFF_ADMIN',
                    'ROLE_STAFF_USER'
                  )
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="red"
                @click="compose_delete(item.raw.countryCode)"
                v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')"
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="pageCount < 3 ? 3 : 7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD ACQUIRER DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("add_country") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('country_name')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="country_data.f_countryName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-text-field
                      :label="$t('country_code')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="country_data.f_countryCode"
                    ></v-text-field>
                  </v-col>
                  <v-col ccols="6" sm="6">
                    <v-text-field
                     :label="$t('alpha_code')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="country_data.f_countryCodeAlpha2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="['fr', 'en']"
                      :label="$t('select language')"
                      v-model="country_data.f_defaultLang"
                      :rules="[required]"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">{{ $t("Close") }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addCountry"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD ACQUIRER DIALOG -->

    <!-- UPDATE ACQUIRER DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("update_country") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('country_name')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="country_data.f_countryName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6">
                    <v-text-field
                     :label="$t('country_code')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="country_data.f_countryCode"
                    ></v-text-field>
                  </v-col>
                  <v-col ccols="6" sm="6">
                    <v-text-field
                      :label="$t('alpha_code')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="country_data.f_countryCodeAlpha2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="['fr', 'en']"
                      :label="$t('select language')"
                      v-model="country_data.f_defaultLang"
                      :rules="[required]"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">{{ $t("Close") }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateCountry"
                >{{ $t("Update") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE ACQUIRER DIALOG -->

    <!-- DELETE ACQUIRER DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <span class="text-h5">do you want to delete?</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog_delete = false"
                  >
                    Close
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="deleteCountry"
                  >
                    Delete
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteCountry">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE ACQUIRER DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Country",
  emits: ["reload"],
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      countries: [], //used

      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      country_data: {
        //used
        f_countryName: "",
        f_countryCode: "",
        f_countryCodeAlpha2: "",
        f_defaultLang: "",
      },

      countryId: "",
      //acquirer_response: [],
      search: "",
      headers: [
        {
          title: this.$t("country_name"),
          align: "start",
          sortable: false,
          key: "countryName",
        },
        { title: this.$t("country_code"), key: "countryCode" },
        { title: this.$t("alpha_code"), key: "countryCodeAlpha2" },
        { title: this.$t("default_lan"), key: "defaultLang", sortable: false },
        { title: this.$t("Actions"), key: "actions", sortable: false },
      ],

      //form
      form: false,
      loading: false,
      email_exist: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  created() {},

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },

    onUpdatePageHandler(newPage) {
      this.page = newPage;
      //this.fetchData()
    },

    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData();
    },
  },

  methods: {
    onSubmit() {
      if (!this.form) return;
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    resetInput() {
      this.country_data.f_countryName = "";
      this.country_data.f_countryCode = "";
      this.country_data.f_countryCodeAlpha2 = "";
      this.country_data.f_defaultLang = "";
    },

    required(v) {
      return !!v || "Field is required";
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
    },

    compose_update(id) {
      this.countryId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.countryId = id;
      this.dialog_delete = true;
    },

    async addCountry() {
      //this.dialog = false
      // console.log("form data", this.acquirer_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.post(
          window.baseurl + "countries",
          {
            countryName: this.country_data.f_countryName,
            countryCode: this.country_data.f_countryCode,
            countryCodeAlpha2: this.country_data.f_countryCodeAlpha2,
            defaultLang: this.country_data.f_defaultLang,
          },
          { headers: { Authorization: "Bearer " + result } }
        );

        if (result.status == 201) {
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("country_created") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.wainting_time);
        }
      } catch (error) {
        // console.log("BIG", error.response);
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "countries/" + this.countryId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((country_response) => {
            // console.log("data1", country_response.data);

            //get acquirer data for selected id and display data in for dialog
            if (country_response.status == 200) {
              //this.acquirer_response = acquirer_response.data,
              // console.log("country Data", this.country_response);
              this.country_data.f_countryName =
                country_response.data.countryName;
              this.country_data.f_countryCode =
                country_response.data.countryCode;
              this.country_data.f_countryCodeAlpha2 =
                country_response.data.countryCodeAlpha2;
              this.country_data.f_defaultLang =
                country_response.data.defaultLang;
            }
          })
        );
    }, //end of requests_handler 2 method

    async updateCountry() {
      //this.dialog_update = false
      // console.log("update form country id", this.countryId);
      // console.log("update form country", this.country_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.put(
          window.baseurl + "countries/" + this.countryId,
          {
            countryName: this.country_data.f_countryName,
            countryCode: this.country_data.f_countryCode,
            countryCodeAlpha2: this.country_data.f_countryCodeAlpha2,
            defaultLang: this.country_data.f_defaultLang,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form country result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("country_updated") });
          window.setInterval(() => {
            this.dialog_update = false;
            this.$emit("reload");
          }, this.wainting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteCountry() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "countries/" + this.countryId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.log("update form acquirer result", result)
        if (result.status == 204) {
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("country_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    async fetchData() {
      // console.log("in fecthData", this.page);
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (
          this.global_permissions.includes(
            "ROLE_STAFF_ADMIN",
            "ROLE_STAFF_USER"
          )
        ) {
          result = await axios.get(window.baseurl + "countries", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("countries_object", result);
          this.countries = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async searchData() {
      // console.log("in searchData", this.query);
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (
          this.global_permissions.includes(
            "ROLE_STAFF_ADMIN",
            "ROLE_STAFF_USER"
          )
        ) {
          result = await axios.get(window.baseurl + "countries/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("countries_search_object", result);
          this.countries = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get data for table
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
